import { gql } from '@apollo/client';

export function getPolicyPersonEnums() {
  return gql`
    query getPolicyPersonEnums {
      PolicyPersonTypeList: __type(name: "PolicyPersonTypeList") {
        name
        enumValues {
          name
          __typename
        }
        __typename
      }
      PhoneType: __type(name: "PhoneType") {
        name
        enumValues {
          name
        }
      }
      Gender: __type(name: "Gender") {
        name
        enumValues {
          name
        }
      }
      PersonAddress: __type(name: "PersonAddress") {
        name
        enumValues {
          name
        }
      }
      PersonAddressType: __type(name: "PersonAddressType") {
        name
        enumValues {
          name
        }
      }
      PersonType: __type(name: "PersonType") {
        name
        enumValues {
          name
        }
      }
      core {
        getTitles {
          id
          title
        }
        getNationalities {
          id
          title
        }
        getOccupationClass {
          id
          title
        }
        getOccupationList {
          id
          code
          description
          arabic
          occupationClassId
          occupationClass {
            id
            title
          }
        }
        getCountries {
          id
          title
        }
        getZones {
          id
          title
        }
      }
    }
  `;
}

export function createProposalPerson() {
  return gql`
    mutation createProposalPerson(
      $mainBusinessPartnerID: String!
      $personInput: CreateProposalPersonInput!
      $proposalID: String
    ) {
      production {
        createProposalPerson(
          mainBusinessPartnerID: $mainBusinessPartnerID
          personInput: $personInput
          proposalID: $proposalID
        )
      }
    }
  `;
}
